import React, { useEffect, useState } from "react"
import { FiMoon, FiSun } from "react-icons/fi"

const STORAGE_KEY = "theme"

const readStored = () => {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch (e) {
    return null
  }
}

const applyTheme = theme => {
  document.documentElement.setAttribute("data-theme", theme)
}

const ThemeToggle = () => {
  // The initial theme is set by an inline script in gatsby-ssr.js before the
  // first paint; this component only mirrors and changes it.
  const [theme, setTheme] = useState(null)

  useEffect(() => {
    setTheme(document.documentElement.getAttribute("data-theme") || "light")

    const media = window.matchMedia("(prefers-color-scheme: dark)")
    const onSystemChange = event => {
      if (readStored()) return
      const next = event.matches ? "dark" : "light"
      applyTheme(next)
      setTheme(next)
    }
    media.addEventListener("change", onSystemChange)
    return () => media.removeEventListener("change", onSystemChange)
  }, [])

  const choose = next => {
    applyTheme(next)
    setTheme(next)
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch (e) {
      // Storage can be unavailable (private mode); the choice still applies.
    }
  }

  return (
    <div className="theme-toggle" role="group" aria-label="Color theme">
      <button
        type="button"
        className="theme-toggle__option"
        data-value="light"
        aria-label="Light theme"
        aria-pressed={theme ? theme === "light" : undefined}
        onClick={() => choose("light")}
      >
        <FiSun aria-hidden="true" />
      </button>
      <button
        type="button"
        className="theme-toggle__option"
        data-value="dark"
        aria-label="Dark theme"
        aria-pressed={theme ? theme === "dark" : undefined}
        onClick={() => choose("dark")}
      >
        <FiMoon aria-hidden="true" />
      </button>
    </div>
  )
}

export default ThemeToggle
